/**
 * Single source of truth for the disability-percentage range accepted by the
 * committee-decision form.
 *
 * Unrelated to commission percentages, which stay capped at 100 and must not
 * use this module.
 */

export const MIN_DISABILITY_PERCENTAGE = 0;

export const MAX_DISABILITY_PERCENTAGE = 235;

/** מחזיר הודעת שגיאה בעברית אם הערך מחוץ לטווח המותר, אחרת null */
export const validateDisabilityPercentage = (value: number): string | null =>
  value < MIN_DISABILITY_PERCENTAGE || value > MAX_DISABILITY_PERCENTAGE
    ? `אחוז נכות חייב להיות בין ${MIN_DISABILITY_PERCENTAGE} ל-${MAX_DISABILITY_PERCENTAGE}`
    : null;
